import { ContentLayout } from '@connected/ui/layouts/content/layout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/documents',
)({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <ContentLayout className="w-full max-w-7xl">
            <ContentLayout.Outlet />
        </ContentLayout>
    );
}
